// extracted by mini-css-extract-plugin
export default {"wrapper":"DeviceInfo_style_wrapper__589L4","rotate":"DeviceInfo_style_rotate__DqKiD"};